import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { URL } from "../Redux/common/url";

function HomeBgBanner2() {
  const slider_list = useSelector((state) =>
    state?.allapi?.slider_list ? state.allapi.slider_list : {}
  );

  const banner = slider_list?.banner ? slider_list.banner : []; // <-- BANNER USED HERE

  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (!banner.length) return;

    const rotate = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % banner.length);
    }, 3000);

    return () => clearInterval(rotate);
  }, [banner.length]);

  // Data nahi aya to kuch mat dikhao
  if (!banner.length) return null;

  const activeImage = URL?.API_BASE_URL + banner[activeIndex]?.image;

  return (
    <div className="homebgbanner">
      <div className="ads-slider-wrapper d-flex justify-content-center align-items-center px-0 mb-4 mt-3">
        <div
          className="ads-slider-box"
          style={{
            backgroundImage: `url(${activeImage})`,
          }}
        ></div>
      </div>
    </div>
  );
}

export default HomeBgBanner2;
